import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { getBTMID } from '/lib/helpers';

const BTM = ({ host }) => {
  const ID = getBTMID(host);
  return (
    <Fragment>
      <script
        dangerouslySetInnerHTML={{
          __html: `(function(w,d,t,r,u)
  {
    var f,n,i;
    w[u]=w[u]||[],f=function()
    {
      var o={ti:" ${ID} ", enableAutoSpaTracking: true};
      o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")
    },
    n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function()
    {
      var s=this.readyState;
      s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null)
    },
    i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)
  })
  (window,document,"script","//bat.bing.com/bat.js","uetq");`,
        }}
      />
    </Fragment>
  );
};

BTM.propTypes = {
  host: PropTypes.string,
};

export default BTM;

export const InjectBTM = {
  init: function (host) {
    if (typeof window === 'undefined') return;

    this.addBingTrackingScript(host);
  },

  addBingTrackingScript: function (host) {
    let ID;

    try {
      ID = getBTMID(host);
    } catch (e) {
      ID = host;
    }

    if (!ID) {
      console.error('BTM: No tracking ID provided');
      return;
    }
    const bingScript = document.createElement('script');
    bingScript.text = `(function(w,d,t,r,u)
    {
      var f,n,i;
      w[u]=w[u]||[],f=function()
      {
        var o={ti:"${ID}", enableAutoSpaTracking: true};
        o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")
      },
      n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function()
      {
        var s=this.readyState;
        s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null)
      },
      i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)
    })
    (window,document,"script","//bat.bing.com/bat.js","uetq");`;

    document.head.appendChild(bingScript);
  },
};
